export default {
  SET_TICKET(state, ticket) {
    state.ticket = ticket;
  },

  SET_LOADING(state, value) {
    state.loading = value;
  },
};
